//Visaulizador de PDF
import React from 'react'

const PdfViewer = ({ docSelected }) => {
    return (
        <>
            {
                docSelected.length > 0 ? 
                    <iframe
                        className="product-detail__pdf-section-view"
                        src={docSelected}
                    />
                : <span style={{ color: "white" }} >Selecciona un documento para visualizar</span>
            }
        </>
       )
}
export default PdfViewer